import orderedJson from 'json-order';

export const getJsonOrderMap = ({
  value,
  columnId,
}: {
  value: string;
  columnId: string;
}) => {
  let valueMap = null;

  try {
    const { map } = orderedJson.parse(value);
    valueMap = map;
  } catch (error) {
    console.error(`Failed to parse ${columnId} JSON`, error);
  }

  return valueMap;
};
